function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Groupe_42",
  "data-name": "Groupe 42",
  transform: "translate(0)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Groupe_41",
  "data-name": "Groupe 41"
}, /*#__PURE__*/React.createElement("path", {
  id: "Trac\\xE9_10",
  "data-name": "Trac\\xE9 10",
  d: "M138.68,21.527,117.765.613A2.09,2.09,0,0,0,116.287,0H72.366A8.374,8.374,0,0,0,64,8.366V92.025a8.374,8.374,0,0,0,8.366,8.366h58.561a8.374,8.374,0,0,0,8.366-8.366V23.006A2.09,2.09,0,0,0,138.68,21.527ZM118.378,7.14l13.774,13.774h-9.591a4.188,4.188,0,0,1-4.183-4.183ZM135.11,92.024a4.188,4.188,0,0,1-4.183,4.183H72.366a4.188,4.188,0,0,1-4.183-4.183V8.366a4.188,4.188,0,0,1,4.183-4.183H114.2V16.732a8.374,8.374,0,0,0,8.366,8.366H135.11Z",
  transform: "translate(-64 0)",
  fill: "#676767"
}), /*#__PURE__*/React.createElement("path", {
  id: "Trac\\xE9_11",
  "data-name": "Trac\\xE9 11",
  d: "M163.761,198.6a60.632,60.632,0,0,1-5-4.316c-1.593-1.593-3.013-3.137-4.246-4.608,1.924-5.946,2.768-9.011,2.768-10.645,0-6.942-2.508-8.366-6.274-8.366-2.862,0-6.274,1.487-6.274,8.566,0,3.121,1.71,6.91,5.1,11.313-.829,2.531-1.8,5.449-2.9,8.74-.527,1.579-1.1,3.041-1.7,4.393-.492.219-.97.441-1.432.672-1.662.831-3.241,1.579-4.706,2.273-6.679,3.162-11.091,5.253-11.091,9.383,0,3,3.258,4.855,6.274,4.855,3.889,0,9.761-5.194,14.05-13.944a83.2,83.2,0,0,1,14.356-3.872c3.5,2.692,7.367,5.267,9.24,5.267,5.186,0,6.274-3,6.274-5.513,0-4.945-5.649-4.945-8.366-4.945A49.57,49.57,0,0,0,163.761,198.6Zm-29.487,18.078a3.3,3.3,0,0,1-2.092-.672c0-1.483,4.422-3.578,8.7-5.6l.827-.39C138.568,214.567,135.461,216.678,134.274,216.678Zm14.64-37.446c0-4.383,1.36-4.383,2.091-4.383,1.479,0,2.092,0,2.092,4.183a33.538,33.538,0,0,1-1.665,6.532C149.791,183.035,148.915,180.868,148.915,179.232Zm1.6,22.479q.2-.545.38-1.1c.776-2.328,1.475-4.42,2.1-6.3q1.3,1.434,2.806,2.937c.392.392,1.364,1.274,2.659,2.379C155.883,200.184,153.141,200.88,150.518,201.711Zm23.494,1.089c0,.94,0,1.33-1.94,1.342a15.41,15.41,0,0,1-3.513-2.006c.59-.065,1.025-.1,1.27-.1C172.92,202.038,173.8,202.34,174.012,202.8Z",
  transform: "translate(-115.451 -137.203)",
  fill: "#676767"
})));

var SvgIcPdf = function SvgIcPdf(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "pdf",
    width: 75.293,
    height: 100.39,
    viewBox: "0 0 75.293 100.39",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcPdf, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ic_pdf.ce825c7d.svg";
export { ForwardRef as ReactComponent };